import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const number = "447444990415"; // WhatsApp business number
  const message = encodeURIComponent("Hi LaneX Labs, I'd like to discuss a project.");
  const href = `https://wa.me/${number}?text=${message}`;

  return (
    <div className="fixed bottom-6 right-6 z-40" data-testid="whatsapp-fab">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            transition={{ duration: 0.25 }}
            className="absolute bottom-16 right-0 w-72 rounded-2xl border border-[color:var(--border)] bg-[color:var(--surface)] p-5 shadow-2xl"
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="overline mb-1">Chat with us</div>
                <div className="font-semibold">We reply in minutes</div>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="w-7 h-7 grid place-items-center rounded-full hover:bg-[color:var(--surface-elev)]"
                aria-label="Close"
              >
                <X size={14} />
              </button>
            </div>
            <p className="mt-3 text-[13px] text-[color:var(--text-muted)]">
              Send us a WhatsApp — we typically respond within business hours.
            </p>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 h-10 px-4 rounded-full bg-[#25D366] text-white font-semibold text-[13px]"
              data-testid="whatsapp-open-chat"
            >
              <MessageCircle size={15} /> Open WhatsApp
            </a>
          </motion.div>
        )}
      </AnimatePresence>
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-xl hover:scale-105 transition-transform"
        aria-label="WhatsApp"
        data-testid="whatsapp-toggle"
      >
        <MessageCircle size={22} />
      </button>
    </div>
  );
}
